<template>
  <div class="page-content">
    <h1 class="page-title">{{ $locale("sideMenu.cinemaWebsite.custom.title") }}</h1>
    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <!-- <el-col :span="14">
        <el-row :gutter="10">
          <el-col :span="10">
          <CommDatePicker
            v-model="onSearch.date"
            :value.sync="onSearch.date"
            width="100%"
            :showWeekly="true"
          />
            </el-col>
            <el-col :span="7">
              <el-input
                :placeholder="$locale('cinemaWebsite.custom.plsInputContent')"
                v-model="onSearch.content"
                @keyup.enter.native="filter_fn"
              >
                <i slot="suffix" class="el-input__icon el-icon-search" @click="filter_fn"></i>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-button class="egl-btn-yellow cinema-website " @click="filter_fn">{{
                $locale("global.search")
              }}</el-button>
            </el-col>
          </el-row>
      </el-col> -->
      <el-col class="ta-r" :span="24">
        <el-button class="egl-btn-yellow" @click="create_fn">{{ $locale("cinemaWebsite.custom.create") }}</el-button>
      </el-col>
    </el-row>
    <!-- table -->
    <el-table
      :data="tableData"
      class="egl-table list-table"
      stripe
    >
      <el-table-column
        class-name="tableRow1"
        :label="$locale('cinemaWebsite.custom.table.header.title')"
        prop="title"
        align="center"
        width="250"
      ></el-table-column>
      <el-table-column
        :label="$locale('cinemaWebsite.custom.table.header.sort')"
        prop="sort"
        align="center"
        width="250"
      ></el-table-column>
      <el-table-column
        class-name="tableRow3"
        :label="$locale('cinemaWebsite.custom.table.header.content')"
        prop="content"
        align="center"
      >
        <template slot-scope="scope">
          <div class="richText" v-html="$util.decodeBase64(scope.row.content)"></div>
        </template>
      </el-table-column>
      <el-table-column align="center" width="160">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="showDetail(scope.row.id)">{{ $locale("global.edit") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="delete_fn(scope.row.id, scope.row.title)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { getCustomisedListService, deleteCustomService } from "@/helpers/service/api/cinemaWebsite";
import countDownAlert from "@/utils/countDownAlert";

export default {
  created() {
    this.getCustomisedList();
  },
  data() {
    return {
      onSearch: {
        date: Date.now().valueOf(),
        content: "",
        sort: "ASC" //ASC DESC 默认ASC
      },
      tableData: [],
      page: 0,
      pageCount: 0,
    };
  },
  methods: {
    // 获取list
    getCustomisedList() {
      if(window.localStorage.getItem("cinemaId")) {
        getCustomisedListService({
          cinemaId: window.localStorage.getItem("cinemaId"),
          page: this.page,
          pageSize: 10,
          sort: this.onSearch.sort
        }).then(res => {
          /**
           * reponse structure
           * data {
           *  count {string}
           *  data {Array}
           * } | null
          */
          if (res.data && res.data.data.length > 0) {
            this.tableData = res.data.data;
          } else {
            this.tableData = [];
          }
          this.pageCount = res.data.count;
        });
      } else {
        console.log("no cinemaId");
      }
    },
    showDetail(id) {
      this.$router.push(`/custom/update/${id}`);
    },
    delete_fn(id, name) {
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}</span>`;
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          deleteCustomService({ id }).then(res => {
            if (!res.success) { return; }
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                this.getCustomisedList();
              }
            });
          });
        });
    },
    create_fn() {
      this.$router.push("/custom/create");
    }
  },
};
</script>